__turbopack_context__.v({
  "slot": "_4lUWvq_slot",
  "withSlot": "_4lUWvq_withSlot",
  "wrapper": "_4lUWvq_wrapper",
});
